
export class CabHubConnection {
    Id: number;
    CabMemberUserId: number;
    HubId: number;
    StatusId: number;
    StartDate: Date;
    EndDate?: Date;
    AdminNotes: string;
    OneMonthCheckInDate: Date;
    OneMonthCheckInNotes?: string;
    SixMonthCheckInDate: Date;
    SixMonthCheckInNotes?: string;
    AgreementUploadId: string;
    CreateDate: Date;
    LastModifiedDate: Date;

    static getDefault(cabMemberId: number, hubId: number): CabHubConnection {
        let connection: CabHubConnection = {
            Id: 0,
            CabMemberUserId: cabMemberId,
            HubId: hubId,
            StatusId: 1, // active,
            StartDate: new Date(1, 1, 1),
            EndDate: new Date(1, 1, 1),
            AdminNotes: "",
            OneMonthCheckInDate: new Date(1, 1, 1),
            OneMonthCheckInNotes: "",
            SixMonthCheckInDate: new Date(1, 1, 1),
            SixMonthCheckInNotes: "",
            AgreementUploadId: "",
            CreateDate: new Date(),
            LastModifiedDate: new Date()
        }
        return connection;
    }
}